import { render, staticRenderFns } from "./detailList.vue?vue&type=template&id=0c3a63f1&"
import script from "./detailList.vue?vue&type=script&lang=js&"
export * from "./detailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3a63f1')) {
      api.createRecord('0c3a63f1', component.options)
    } else {
      api.reload('0c3a63f1', component.options)
    }
    module.hot.accept("./detailList.vue?vue&type=template&id=0c3a63f1&", function () {
      api.rerender('0c3a63f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xunfei/detail/detailList.vue"
export default component.exports